/**
 * Iframe-side primitive command handlers.
 * Executed when iframe receives postMessage from parent or processes URL on mount.
 *
 * Security: only navigation + UI state. No mutations, no privileged ops.
 */
import type { NavigateFunction } from 'react-router-dom';
import type { IframeCommand } from './types';

export interface IframeCommandDeps {
  navigate: NavigateFunction;
  setLendiPending: (v: boolean) => void;
}

export const executeIframeCommand = (
  cmd: IframeCommand,
  deps: IframeCommandDeps
): void => {
  switch (cmd.action) {
    case 'property.open':
      deps.navigate(`/properties/${encodeURIComponent(cmd.payload.propertyId)}`);
      return;
    case 'lendi.expand':
      deps.setLendiPending(true);
      return;
  }
};
